<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          label="Identifikavimo kodas"
          tooltip="Hipoteka. Turtas. Vidaus vandenų transportas. Identifikavimo kodas"
          :readonly="turtasReadonly || !sudarymas"
          :counter="10"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Registro (identifikavimo) numeris"
          tooltip="Hipoteka. Turtas. Vidaus vandenų transportas. Registro numeris"
          :readonly="turtasReadonly"
          :counter="20"
          v-model="formData.tur_laivelis_registracijos_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Pavadinimas"
          tooltip="Hipoteka. Turtas. Vidaus vandenų transportas. Pavadinimas"
          :readonly="turtasReadonly"
          :counter="40"
          v-model="formData.tur_laivelis_pavadinimas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Tipas, modelis"
          tooltip="Hipoteka. Turtas. Vidaus vandenų transportas. Tipas, modelis"
          :readonly="turtasReadonly"
          :counter="80"
          v-model="formData.tur_laivelis_modelis"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Dokumento išdavimo vieta"
          tooltip="Hipoteka. Turtas. Vidaus vandenų transportas. Dokumento išdavimo vieta"
          :readonly="turtasReadonly"
          :counter="80"
          v-model="formData.tur_laivelis_isdavimo_vieta"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-date-picker
          label="Registracijos data"
          tooltip="Hipoteka. Turtas. Vidaus vandenų transportas. Registracijos data"
          :readonly="turtasReadonly"
          v-model="formData.tur_laivelis_registracijos_data"
        />
      </v-col>

      <v-col cols="12" md="6" v-if="showIsregistruotas">
        <el-checkbox
          class="mb-3 mt-0"
          label="Išregistruota"
          tooltip="Hipoteka. Turtas. Vidaus vandenų transportas. Išregistruotas"
          :readonly="turtasReadonly"
          v-model="formData.tur_laivelis_isregistruotas"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasLaivelis',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
    showIsregistruotas() {
      return this.formData.tur_laivelis_isregistruotas
    },
  },
}
</script>
